import { render, staticRenderFns } from "./AutomaticMessageTile.vue?vue&type=template&id=6a0c7206&scoped=true&"
import script from "./AutomaticMessageTile.vue?vue&type=script&lang=ts&"
export * from "./AutomaticMessageTile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0c7206",
  null
  
)

export default component.exports